import React, { FC, useCallback } from 'react';
import styles from './index.module.scss';
import { Form, Button } from 'src/common';
import Checkbox from 'antd/lib/checkbox';
import { SearchProfilesColorsDict } from 'src/helpers/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTag } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import checkboxStyles from 'src/common/Checkbox/index.module.scss';

export interface IGroupProps {
  groupFormPath: string[] | string;
  title?: string;
  color?: SearchProfilesColorsDict;
  emptyMessage: string;
  items: {
    occurrences?: number;
    value: string;
    label: string;
  }[];
  onChange?: (checkedValue: CheckboxValueType[]) => void;
  onSelectGroup?: (groupName: string, selectedValue: string[]) => void;
  isSelectAll?: boolean;
  hideCheckbox?: boolean;
  onRemove?: () => void;
}

export const Group: FC<IGroupProps> = props => {
  const {
    color,
    groupFormPath,
    title,
    items,
    emptyMessage,
    onSelectGroup,
    isSelectAll,
    hideCheckbox,
    onChange,
    onRemove
  } = props;

  const onClickGroup = useCallback(() => {
    onSelectGroup && onSelectGroup(groupFormPath[1], !isSelectAll ? items.map(item => item.value) : []);
  }, [onSelectGroup, groupFormPath, isSelectAll, items]);
  return (
    <div className={classNames(styles.group, { [styles.withEyes]: !!hideCheckbox })}>
      {title && (
        <div className={styles.title}>
          <div>
            {!!color && <FontAwesomeIcon icon={faTag} style={{ color }} className={styles.colorIndicator} />}
            <Button
              type={'link'}
              onClick={onClickGroup}
              className={classNames(styles.titleToggle, {
                [styles.isSelectedAll]: isSelectAll
              })}
            >
              {title} {!!hideCheckbox && isSelectAll && <FontAwesomeIcon icon={faEye} />}
            </Button>
          </div>
          {!!onRemove && <Button type={'text'} icon={<FontAwesomeIcon icon={faTimes} onClick={onRemove} />} />}
        </div>
      )}

      {!!items.length && (
        <Form.Item name={groupFormPath}>
          <Checkbox.Group className={styles.termsContainer} onChange={onChange}>
            {items.map(item => (
              <div key={item.value} className={styles.checkboxWrap}>
                <Checkbox
                  value={item.value}
                  disabled={!item.occurrences}
                  className={classNames(checkboxStyles.checkbox, styles.checkbox, {
                    [styles.withEyes]: !!hideCheckbox
                  })}
                >
                  <span className={styles.checkboxLabel}>{item.label}</span>
                  {typeof item.occurrences === 'number' && (
                    <span className={styles.occurrences}>({item.occurrences})</span>
                  )}
                  {!!hideCheckbox && !isSelectAll && <FontAwesomeIcon icon={faEye} />}
                </Checkbox>
              </div>
            ))}
          </Checkbox.Group>
        </Form.Item>
      )}
      {!items.length && <span className={styles.emptyMessage}>{emptyMessage}</span>}
    </div>
  );
};
export default Group;
